import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { DashboardStaffResponse } from "@/api/types";
import { useDashboardRequest } from "./dashboard-request";

export function useDashboardStaff() {
  const dashboard = useDashboardRequest();

  return useQuery({
    queryKey: dashboard.queryKey("staff"),
    queryFn: () =>
      api.get("dashboard/staff", dashboard.requestOptions()).json<DashboardStaffResponse>(),
    staleTime: 5 * 60_000,
  });
}
